import React from "react"
import styles from "./styles.js"
import InputAdornment from "@material-ui/core/InputAdornment"
import IconButton from "@material-ui/core/IconButton"
import ClearIcon from "@material-ui/icons/Close"
import Tooltip from "@material-ui/core/Tooltip"
import FormatAlignJustifyIcon from "@mui/icons-material/FormatAlignJustify"
import { componentOptions } from "../../constants/componentOptions"
import QrCode2Icon from "@mui/icons-material/QrCode2"

const scannerBtnOptions = (deviceId, handleSetDeviceId, scannerSupported, scannerBtnOptionsSelectionHandler) => {
	return deviceId ? (
		<InputAdornment position="end">
			<IconButton edge="end" aria-label="Clear" onClick={() => handleSetDeviceId("")}>
				<ClearIcon />
			</IconButton>
		</InputAdornment>
	) : scannerSupported ? (
		<>
			<InputAdornment position="end">
				<IconButton
					className={styles.barCodeButton}
					edge="end"
					aria-label="Barcode Scan"
					onClick={() =>
						scannerBtnOptionsSelectionHandler("barCode", {
							name: "node assignment",
							validation: [],
							enabled: true,
							isMaster: false,
							method: "setNodeEnclosure",
						})
					}
				>
					<Tooltip title="Barcode Scan">
						<FormatAlignJustifyIcon />
					</Tooltip>
				</IconButton>
			</InputAdornment>
			<InputAdornment position="end">
				<IconButton
					edge="end"
					aria-label="QR Scan"
					onClick={() => scannerBtnOptionsSelectionHandler("qrCode", componentOptions[4])}
				>
					<Tooltip title="QR Code Scan">
						<QrCode2Icon />
					</Tooltip>
				</IconButton>
			</InputAdornment>
		</>
	) : null
}

export default scannerBtnOptions
